// extracted by mini-css-extract-plugin
export default {"card":"Card_card__vp0Mm","shadow":"Card_shadow__b64ZQ"};